import {doc} from '../docs.js';
import {NFT, START, STOP, TICK} from "messaging/message-types.js";
import ZScript from "../../custom/ZScript.js";
import ZCanvas3D from "../../custom/ZCanvas3D.js";
import ZShaderMaterial from "../../custom/ZShaderMaterial.js";
import * as THREE from "three";

doc(
    "three.canvas",
    {},
    "Creates a threejs canvas (3D)",
    () => 0,
    {
        inlets: 0,
        tags: "Graphics"
    });

export const canvas3d = (object) => {
    let zcanvas = new ZCanvas3D(object);
    object.effect = zcanvas;
    object.width = 300;
    object.height = 300;
    
    object.needsLoad = true;
    return ([msg]) => {
        if (msg === START) {
            object.effect.sendMessage('size', [object.width, object.height]);
        }
    };
};

doc(
    "three.vector3",
    {
    },
    "Creates a 3-dimensional vector object",
    undefined,
    {
        isHot: true,
        inlets: 3,
        tags: "Graphics"
    });

const vector3 = (object, b, c) => {
    return ([a]) => {
        return new THREE.Vector3(a, b(), c());
    };
};

doc(
    "three.vector2",
    {
    },
    "Creates a 2-dimensional vector object",
    undefined,
    {
        isHot: true,
        inlets: 2,
        tags: "Graphics"
    });

const vector2 = (object, y) => {
    return ([x]) => {
        return new THREE.Vector2(x,y());
    };
};


doc(
    "three.gray",
    {
        "shade":"",
    },
    "Gray");

export const gray = (object) => {
    return ([shade]) => {
        let color = new THREE.Color(shade, shade, shade);
        return [[shade, shade, shade]];
    };
};


export const three = {
    "three.gray": gray,
    "three.vector3": vector3,
    "three.vector2": vector2,
    "three.canvas": canvas3d,
};
